import { useParams } from 'peach/router'

import { useAuthCompanyId } from 'core/auth/authStore'
import { useApi } from 'core/legacy/api/ApiProvider'

import useDataMutation from './internal/useDataMutation'
import useDataQuery from './internal/useDataQuery'

const useQueryApi = ({ companyId: passedCompanyId, ...options } = {}) => {
  const { companyId: paramsCompanyId, ...params } = useParams()

  const sessionCompanyId = useAuthCompanyId()

  const companyId = passedCompanyId || paramsCompanyId || sessionCompanyId

  const api = useApi()

  const $options = { companyId, ...params, ...options }

  return [api, $options, { params, options }]
}

export { useQueryApi, useDataQuery, useDataMutation }
